module.exports = __webpack_public_path__ + "static/media/Ambrishbhai.d75becba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Ambrishbhai.jpg
// module id = 1130
// module chunks = 0